import { Api, Domain } from '@3nickels/data-modules';

export function mapAggInvestmentRestToAggInvestment(
  data: Api.AggInvestmentRest
): Domain.AggInvestment {
  const account = data.account
    ? Domain.mapInvestmentAccountRestToPlanData(data.account)
    : undefined;

  return {
    ...mapAutoBindableRestToAutoBindableAccount(data),
    account,
    compatiblePlanTypes: data.compatiblePlanTypes,
  };
}

export function mapAutoBindableRestToAutoBindableAccount(
  data: Api.IAutoBindAccountRest
): Domain.IAutoBindableAccount {
  return {
    ...data,
  } as Domain.IAutoBindableAccount;
}

export function mapAutoLinkResultRestToAccounts(
  data: Api.AutoLinkResultRest
): Domain.IAutoBindableAccount[] {
  const allAccounts: Domain.IAutoBindableAccount[] = [];

  for (let i = 0; i < data.investmentAccounts.length; i++) {
    allAccounts.push(mapAggInvestmentRestToAggInvestment(data.investmentAccounts[i]));
  }

  for (let i = 0; i < data.autoBindableAccounts.length; i++) {
    allAccounts.push(mapAutoBindableRestToAutoBindableAccount(data.autoBindableAccounts[i]));
  }

  return allAccounts;
}
